<template>

    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                        <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                        <div class="flex-1">
                            <h3 class="m-0">Rangkuman Transaksi</h3>
                            <p class="mb-0">Ini rangkuman bulan {{myGlobal.BulanOnly(data.bulan)}}</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pembayaran</label>
                                            <h3 class="m-0 text-success">{{myGlobal.ribu(data.pembayaran)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pemasukkan Lain-lain</label>
                                            <h3 class="m-0 text-success">{{myGlobal.ribu(data.masuk)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Pengeluaran</label>
                                            <h3 class="m-0 text-danger">{{myGlobal.ribu(data.keluar)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Total Pendapatan</label>
                                            <h3 class="m-0 text-info">{{myGlobal.ribu(data.total)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Uang Belum disetor</label>
                                            <h3 class="m-0 text-warning">{{myGlobal.ribu(data.sisa)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <div class="form-group">
                                            <label class="bmd-label-floating">Sudah disetor</label>
                                            <h3 class="m-0 text-success">{{myGlobal.ribu(data.setor)}}</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import moment from 'moment'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		moment,
	}, 
    setup() {
        const data = reactive({
            loading: true,
            pembayaran: "0",
            keluar: "0",
            masuk: "0",
            total: 0,
            setor: "0",
            sisa: "",
            bulan: ""
        })

        const get = {
            datax() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken'),
                    bulan: sessionStorage.getItem('bulanIdBase'),
                    tahun: sessionStorage.getItem('tahunBase')
                }; 
            
                var apiUrl = inter.Rangkuman();
                myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var d = x.data;

                        data.pembayaran = myGlobal.isNull(d.pembayaran);
                        data.keluar = myGlobal.isNull(d.keluar);
                        data.masuk = myGlobal.isNull(d.masuk);

                        data.total = ( parseInt(data.pembayaran) + parseInt(data.masuk) ) - parseInt(data.keluar);

                        data.setor = d.setor;
                        data.sisa = d.sisa;
                        data.bulan = d.bulan;

                    } else {
                        
                    }
                })
            }
        }
        return {
            data,
            myGlobal,
            get
        }
    },
	mounted() {
        document.title = "Rangkuman";
        
        this.get.datax();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pembukuan/rangkuman.vue